import useSWR from "swr";
import { UseCleaningModel } from "./types";
import { getCleaningData } from "./cleaning-service";

const useCleaningData = (): UseCleaningModel => {
  const { data, error, mutate } = useSWR(`/cleaning/`, () => getCleaningData());

  return {
    data: data?.results,
    isLoading: !error && !data,
    error,
    mutate,
  };
};

export default useCleaningData;
